var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2E642C",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 197.667 197.667",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.583,146.142v44.025c0,4.142-3.357,7.5-7.5,7.5h-164.5c-4.142,0-7.5-3.358-7.5-7.5v-44.025 c0-16.349,11.019-30.763,26.796-35.05l35.933-9.765c3.286-0.894,6.76,0.539,8.462,3.487l18.559,32.144l18.559-32.144 c1.702-2.948,5.18-4.378,8.462-3.487l35.933,9.765C177.564,115.379,188.583,129.792,188.583,146.142z M98.833,0 C77.722,0,60.547,20.479,60.547,45.652c0,25.172,17.175,45.652,38.287,45.652s38.286-20.479,38.286-45.652 C137.12,20.479,119.945,0,98.833,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/coach.686fcfe5c805bc03788a0e296b3244b3.svg";
export { ForwardRef as ReactComponent };